import { Injectable, NgZone } from '@angular/core'
import { request } from '../request'
import { MatSnackBar } from '@angular/material/snack-bar'
import moment from 'moment'

@Injectable({providedIn: 'root'})
export class VersionCheckService {
  // this will be replaced by actual hash post-build.js
  private currentHash: string = '{{POST_BUILD_ENTERS_HASH_HERE}}';
  private frequencyMinutes: number = 30; // 30 minutes
  private frequency: number = 1000 * 60 * this.frequencyMinutes;
  private url: string = `/api/deploy_version.json`;
  private lastShownStorageKey: string = 'refresh_last_shown_at';
  private thresholdHours: number = 8; // Don't remind to refresh twice in 8 hour period

  constructor(
    private matSnackBar: MatSnackBar,
    private zone: NgZone
  ) {}

  initVersionCheck(): void {
    setInterval(() => {
      this.checkVersion()
    }, this.frequency)
  }

  private checkVersion(): void {
    // timestamp these requests to invalidate caches
    request.get(this.url + '?t=' + new Date().getTime())
      .then(response => {
        const hash = response.hash
        const hashChanged = this.hasHashChanged(this.currentHash, hash)

        // If new version, prompt to reload
        if (hashChanged && this.shownMoreThanNHoursAgo()) {
          localStorage.setItem(this.lastShownStorageKey, new Date().toString())

          this.matSnackBar.open('A new version of the app is required. Refresh the page.', 'Reload')
          .onAction().subscribe(() => {
            this.zone.runOutsideAngular(() => location.reload())
            // Update local store of new dismissal time
          })
        }
        // store the new hash so we wouldn't trigger versionChange again
        // only necessary in case you did not force refresh
        this.currentHash = hash
      })
      .catch(err => {
        console.error(err, 'Could not get version')
      })
  }

  private hasHashChanged(currentHash: string, newHash: string): boolean {
    if (!currentHash || currentHash === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
        return false
    }

    return currentHash !== newHash
  }

  private shownMoreThanNHoursAgo(): boolean {
    const lastShown = localStorage.getItem(this.lastShownStorageKey)
    if (!lastShown) {
      return true // Has never been shown before
    }
    else {
      const nHoursAgo = moment().subtract(this.thresholdHours, 'hours')
      const lastShownMoment = moment(new Date(lastShown))
      return lastShownMoment.isBefore(nHoursAgo)
    }
  }

}
